export const FIELDS_FORM = {
    'contactName': {
        name: 'contactName',
        type: 'text',
        placeholder: '*Name',
        isRequired: true,
        isError: false,
        message: 'Please enter name.',
        value: '',
        maxlength: 50,
    },
    'contactLastName': {
        name: 'contactLastName',
        type: 'text',
        placeholder: '*Last Name',
        isRequired: true,
        isError: false,
        message: 'Please enter last name.',
        value: '',
        maxlength: 50,
    },
    'contactEmail': {
        name: 'contactEmail',
        type: 'email',
        placeholder: '*E-mail',
        isRequired: true,
        isError: false,
        message: 'Please enter a valid email address.',
        value: '',
        maxlength: 75,
    },
    'contactPhone': {
        name: 'contactPhone',
        type: 'phone',
        placeholder: '*Phone',
        isRequired: true,
        isError: false,
        message: 'Enter valid phone.',
        value: '',
        maxlength: 20,
    },
    'contactCompany': {
        name: 'contactCompany',
        type: 'text',
        placeholder: '*Company',
        isRequired: true,
        isError: false,
        message: 'Please enter company.',
        value: '',
        maxlength: 100,
    },
    'contactCity': {
        name: 'contactCity',
        type: 'text',
        placeholder: '*City',
        isRequired: true,
        isError: false,
        message: 'Please enter your city.',
        value: '',
        maxlength: 100,
    },
    'contactState': {
        name: 'contactState',
        type: 'text',
        placeholder: '*State',
        isRequired: true,
        isError: false,
        message: 'Please enter state.',
        value: '',
        maxlength: 100,
    }
};

export const FIELDS_CHECK_FORM = {
'socialMedia': {
    name: 'socialMedia',
    type: 'radio',
    text: 'Social media (Twitter, Facebook or Instagram)',
    value: 'socialMedia',
    isCheck: false,
},
'website': {
    name: 'website',
    type: 'radio',
    text: 'Website',
    value: 'website',
    isCheck: false,
},
'other': {
    name: 'other',
    type: 'radio',
    text: 'Other',
    value: 'other',
    isCheck: false,
},
};